var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isVisible ? _c('span', {
    directives: [{
      name: "b-hover",
      rawName: "v-b-hover",
      value: _vm.handleHover,
      expression: "handleHover"
    }],
    staticClass: "omni-dropdown-icon"
  }, [_c('FontAwesomeIcon', {
    staticClass: "icon",
    attrs: {
      "icon": _vm.icon
    }
  }), _vm.isHovering ? _c('OmniDropdownCard', _vm._b({}, 'OmniDropdownCard', _vm.$props, false)) : _vm._e()], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }